import { render, staticRenderFns } from "./shorderdetails.vue?vue&type=template&id=f3a282d6&scoped=true&"
import script from "./shorderdetails.vue?vue&type=script&lang=js&"
export * from "./shorderdetails.vue?vue&type=script&lang=js&"
import style0 from "./shorderdetails.vue?vue&type=style&index=0&id=f3a282d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a282d6",
  null
  
)

export default component.exports